<template>
  <v-container fluid>
    <div class="modal-padding cp3-modal fix-error-message">
      <v-row>
        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">Edit Teacher:</div>
            <div class="field-data">
              <v-text-field
                v-model="name"
                class="fix-200"
              ></v-text-field>
              <InputError :data="error.name" />
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">Email ID:</div>
            <div class="field-data">
              <v-text-field
                v-model="email"
                class="fix-200"
              ></v-text-field>
              <InputError :data="error.email" />
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">
              Select Category:
            </div>
            <div class="field-data">
              <v-select
                @change="onManuallyChangeCategory()"
                v-model="selectedClass"
                :items="class_code"
                item-text="title"
                item-value="title"
                 @focus="focused"
				@blur="blurred"
				dense
                outlined
                class="fix-200"
              ></v-select>
              <InputError :data="error.data_type" />
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">
              Subject
            </div>
            <div class="field-data">
              <v-select
                v-model="selectedSubject"
                :items="subjects"
                item-text="title"
                item-value="id"
                @focus="focused"
				@blur="blurred"
				dense
                outlined
                multiple
                class="fix-200"
                filled
              ></v-select>
              <InputError :data="error.subjects" />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <div class="select-center-blk">
            <div class="teacher-border">
              <div
                v-if="selectedCenterList.length"
                class="selectedCenterListouter"
                id="centerContainer"
               
              >
                <div
                  v-for="center in selectedCenterList"
                  class="selectedCenterList" :id="center.class"
                
                 
                  
                >
                 <div  class="center-name-v" >
                 
                      {{ center.text }}
                    
                  </div>
                  <div class="radio-center">
                    <div
                      class="check-cust center-check"
                      v-for="batch in center.batches"
                      :title="batch.text"
                    >
                      <v-checkbox
                        v-model="batch.checked"
                        :label="batch.text"
                        :readonly="getBatchReadOnly(batch)"
                        :disabled="getBatchReadOnly(batch) || batch.disabled"
                        dense
                        hide-details
                      ></v-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="select-center cp3-select-center">
                  <v-select
                    v-model="selectedCenterId"
                    :items="centers"
                    item-text="text"
                    dense
                    no-data-text="No centers available"
                    class="fix-200"
                    hide-details 
					@focus="focused"
					@blur="blurred"
                    filled
                    solo
                    attach
                    auto
                    placeholder="Add Center & Batch"
                    ref="container"
                  ></v-select>
                </div>
              </div>
            </div>
            <InputError :data="error.batches" />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <div class="bottom-btn">
            <v-btn
              :loading="approvalLoading"
              @click="onSaveOrApprove(1)"
              class="right-btn cust-btn"
              color="primary"
              >Approve</v-btn
            >
            <v-btn
              :loading="saveLoading"
              @click="onSaveOrApprove(0)"
              class="right-btn cust-btn"
              color="primary"
              >Save & return</v-btn
            >
            <v-btn
              @click="onClose({ status: false })"
              class="right-btn cust-btn"
              color="primary"
              >Cancel</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "EditTeacherDetails",
  props: ["onClose", "data", "status", "isApprove"],
  data() {
    return {
      name: this.data ? this.data.name : "",
      email: this.data ? this.data.email : "",
      approvalLoading: false,
      saveLoading: false,
      classes: [],
      class_code: [],
      subjects: [],
      newSubjects: [],
      selectedSubject: this.data
        ? this.data.subjects.map((x) => Number(x))
        : null,
      selectedClass: this.data ? this.data.class_code : null,
      selectedClassId: null,
      error: {
        name: {
          type: null,
          message: "Please enter name",
        },
        data_type: {
          type: null,
          message: "Please select class",
        },
        email: {
          type: null,
          message: "Please enter email address",
        },
        subjects: {
          type: null,
          message: "Please Select Subject",
        },
        batches: {
          type: null,
          message: "Please Select Batch",
        },
      },
      centers: [],
      allCenters: [],
      selectedCenterList: [],
      sortedCenterName: [],
      selectedCenterId: null,
      showAddcenterButton: true,
    };
  },
  methods: {
    ...mapActions({
      getClasses: "userStore/getClasses",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      signUp: "userStore/signUp",
      getBatches: "centerAndBatchStore/getBatches",
      getCenters: "centerAndBatchStore/getCenters",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      updateExternalUser: "userStore/updateExternalUser",
      getTeacherDetails: "userStore/getTeacherDetails",
    }),
    getCentersFunction() {
      if (this.isCoordinator()) {
        return "getCentersByUser";
      }
      return "getCenters";
    },
    isCoordinator() {
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (user && user.role_id === constants.ROLES_ID.CO) {
        return true;
      }
      return false;
    },
    onSaveOrApprove(requireApproval) {
      if (this.validate()) {
        let batches = [];
        this.selectedCenterList.map((sc) => {
          return sc.batches.map((b) => {
            if (b.checked) {
              batches.push(b.value);
            }
          });
        });
        let reqData = {
          role_id: this.roleIds.TR,
          status: 1,
          user_id: this.data.id,
          class: this.selectedClass,
          is_approved: requireApproval || undefined,
          name: this.name,
          email: this.email,
          categories: this.selectedSubject,
          batches: batches,
        };
        this.approvalLoading = requireApproval;
        this.saveLoading = !requireApproval;
        this.updateExternalUser(reqData)
          .then((response) => {
            this.approvalLoading = false;
            this.saveLoading = false;
            if (requireApproval === 1) {
              this.$toasted.success(`Approval status changed successfully`, {
                icon: "check_circle",
              });
            } else {
              this.$toasted.success(`Teacher Details Updated successfully`, {
                icon: "check_circle",
              });
            }
            this.onClose({ status: false, reload: true });
          })
          .catch((err) => {
            this.approvalLoading = false;
              this.approvalLoading = false;
            this.saveLoading = false;
          });
      }
    },
    getBatchReadOnly(batch) {
      return (
        this.allCenters.filter(
          (x) => Number(x.value) === Number(batch.center_id)
        ).length === 0
      );
    },
    requestGetClasses() {
      let reqData = {
        level: 1,
      };
      let me = this;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          me.loading = false;
          me.class_code = response;
          me.selectedClassId =
            me.class_code[
              me.class_code.findIndex((x) => x.title === me.selectedClass)
            ].id;
          if (me.selectedClassId) this.getSubjects({ change: true });
        })
        .catch((err) => {
          me.loading = false;
        });
    },
    getSubjects(item) {
      let reqData = {
        level: 2,
        parent: this.selectedClassId,
      };
      this.subjects = [];
      if (item && !item.change) {
        this.selectedSubject = [];
      }
      this.$root.showLoader = true;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.subjects = response;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onManuallyChangeCategory(class_code) {
      this.subjects = [];
      this.selectedSubject = [];
      this.selectedClassId = this.class_code[
        this.class_code.findIndex((x) => x.title === this.selectedClass)
      ].id;

      this.getSubjects({ change: false });
    },
    validate() {
      this.email = this.removeWhiteSpacesFromEmail(this.email);
      let isValid = true;
      this.error.name.type = null;
      this.error.email.type = null;
      this.error.data_type.type = null;
      this.error.subjects.type = null;
      this.error.batches.type = null;

      let batches = [];
      this.selectedCenterList.map((sc) => {
        return sc.batches.map((b) => {
          if (b.checked) {
            batches.push(b.value);
          }
        });
      });
      if (!this.name || this.name.length < 1) {
        this.error.name.type = "error";
        isValid = false;
      }
      if (!this.email) {
        this.error.email.type = "error";
        isValid = false;
      }
      if (!this.class_code) {
        this.error.data_type.type = "error";
        isValid = false;
      }
      if (this.selectedSubject.length <= 0) {
        this.error.subjects.type = "error";
        isValid = false;
      }
      if (!batches || batches.length <= 0) {
        this.error.batches.type = "error";
        isValid = false;
      }
       if (!this.email || this.email.length < 1) {
        this.error.email.type = "error";
        this.error.email.message = "Please enter email ID.";
        isValid = false;
      } else if (!this.isValidEmail(this.email)) {
        this.error.email.type = "error";
        this.error.email.message =
          "Please enter a valid email ID.";
        isValid = false;
      }
      return isValid;
    },
    requestGetCenters(alreadySelectedCenter) {
      this.centers = [];
      this.$root.showLoader = true;
      this[this.getCentersFunction()]()
        .then((response) => {
          this.$root.showLoader = false;
          this.allCenters = response.map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
          this.centers = this.allCenters.filter((c) => {
            return alreadySelectedCenter.indexOf(c.value) === -1;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;
    },
    requestGetBatch(centerId) {
      let reqData = {
        center_id: [centerId],
      };

      this.getBatches(reqData)
        .then((response) => {
          this.loading = false;
          let tmpCenter = this.centers.filter((x) => x.value === centerId);
          if (response && response.list && response.list.length) {
            let tmpBatch = response.list.map((x) => {
              let c = {};
              c.text = x.name;
              c.value = x.id;
              c.center_id = x.center_id;
              c.checked = false;
              c.subject_id = x.subject_ids.split(',').map(s=>parseInt(s));
              return c;
            });
            let maxIdx = this.selectedCenterList.length;
            this.selectedCenterList.push({
              ...tmpCenter[0],
              batches: tmpBatch,
              class: maxIdx + 'center'
            });
            
            this.selectedCenterList.sort(function(a, b){
                  var nameA=a.text.toLowerCase(), nameB=b.text.toLowerCase();
                  if (nameA < nameB) 
                    return -1;
                  if (nameA > nameB)
                    return 1;
                  return 0; 
                  });

            this.centers = this.centers.filter((x) => x.value !== centerId);
            this.disableBatches()

          } else {
            this.$toasted.error(
              `Batches not available for center ${tmpCenter[0].text}`,
              { icon: "info" }
            );
            this.centers = this.centers.filter((x) => x.value !== centerId);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getAlreadySelectedBatches() {
      const reqData = {
        teacher_id: this.data.id,
      };
      let tempcenter = [];
      let tempBatches = [];
      this.getTeacherDetails(reqData)
        .then((response) => {
          let selectedCenter = [];
          response.centerBatches.map((res,idx) => {
            let center = {
              text: res.name,
              value: res.id,
              class: idx + 'center',
              batches: [],
            };
            tempcenter.push(res.id);
            res.batches.map((b) => {
              let batch = {
                text: b.name,
                value: b.id,
                center_id: b.center_id,
                checked: b.is_selected === 1,
                 	subject_id : b.subject_ids.map(s=>parseInt(s.id)),

				disabled:false
              };
              tempBatches.push(b.id);
              center.batches.push(batch);
            });
            selectedCenter.push(center);
          });
          this.selectedCenterList = selectedCenter;
     
         this.selectedCenterList.sort(function(a, b){
                  var nameA=a.text.toLowerCase(), nameB=b.text.toLowerCase();
                  if (nameA < nameB) 
                    return -1;
                  if (nameA > nameB)
                    return 1;
                  return 0; 
                  });
         
        
			this.disableBatches();
            this.requestGetCenters(tempcenter);
        })
        .catch((err) => {
          console.log(err);
        });
      return tempcenter;
    },
    testLogicForScroll() {
      var elem = document.getElementById(this.selectedCenterList.length - 1 + 'center');
      elem.scrollIntoView();
    },
	focused() {
            this.persistentStatus(true);
        },
    blurred(e) {
        _.debounce(this.persistentStatus, 200)(false, this);
    },
	persistentStatus(val) {
        this.$nextTick(() => {
            this.$emit("persistentStatus", val);
        });
    },
    disableBatches(){
			this.selectedCenterList.map(center => {
				center.batches.map(b => {
					if(this.selectedSubject && this.selectedSubject.length){
					
						b.disabled = !(this.selectedSubject.findIndex(s=>b.subject_id && b.subject_id.length && b.subject_id.includes(s)) >=0)
					}else{
						b.disabled = true
					}
				})
			})
}
  },
  mounted() {   
    this.requestGetClasses();
    this.getAlreadySelectedBatches();
  },
  watch: {
    status(val) {
      this.selectedClass = this.data ? this.data.class_code : null;
      this.name = this.data ? this.data.name : null;
      this.email = this.data ? this.data.email : null;
      this.selectedSubject = this.data ? this.data.subjects : [];
      this.requestGetClasses();
      this.getAlreadySelectedBatches();
      this.error.name.type = null;
      this.error.email.type = null;
      this.error.data_type.type = null;
      this.error.subjects.type = null;
      this.error.batches.type = null;
      this.selectedCenterId = null;
    },
    selectedClass(val) {
      this.error.class_code.type = null;
    },
    name() {
      this.error.name.type = null;
    },
    selectedCenterId(val) {
      if (this.selectedCenterId) {
        this.showAddcenterButton = true;
        this.requestGetBatch(val);       
      }
    },
    selectedCenterList(val)
    {
      let me = this;
       setTimeout(()=> {
            me.testLogicForScroll();
        }, 100);
      
    },
	selectedSubject(){
            this.disableBatches()

	}
  },
};
</script>
